




















import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo } from './api';

const baseUrl = '0610KHZW';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '活动首页',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '我要参赛',
      path: `/${baseUrl}/save`,
      id: 2,
    },
    // {
    //   title: '我要投稿',
    //   path: `/${baseUrl}/user`,
    //   id: 3,
    // },
    {
      title: '活动规则',
      path: `/${baseUrl}/rule`,
      id: 3,
    },
    {
      title: '活动资讯',
      path: `/${baseUrl}/news`,
      id: 4,
    },
    {
      title: '学校联系人',
      path: `/${baseUrl}/signUp`,
      id: 5,
    },
  ];
  activeTab = 0;
  clientHeight = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '第三届重庆青少年科幻征文大赛',
      url: location.href,
      subtitle: `我正在参加重庆青少年科幻征文大赛，为我加油!`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '第三届重庆青少年科幻征文大赛',
        subtitle: `我正在参加重庆青少年科幻征文大赛，为我加油!`,
        image: cover,
      });
    }
  }

  async created() {
    this.clientHeight = document.documentElement.clientHeight;
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
